<template>
  <confirm-action-dialog
    :title="$t('components.fleet.FleetVehicleDetailDocumentCard.addDocumentDialogTitle')"
    :isDialogActive.sync="dialogActive"
    :leftDisabled="isLoading"
    :rightDisabled="isRightDisabled"
    :rightLoading="isLoading"
    :leftText="$t('back')"
    width="800px"
    @rightClick="rightClick"
    @leftClick="leftClick"
  >
    <paginated-table
      :store="store"
      :predefinedFilter="store.commonPredefinedFilter"
      :selectedItems.sync="selected"
      :baseQuery="{ partnerId }"
      :showSelect="true"
      :headers="headers"
    />
  </confirm-action-dialog>
</template>

<script lang="ts">
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import PaginatedTable from "@/components/utility/v2/PaginatedTable.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IPageFilterElement } from "@/models/page-filter-element.entity";
import { ISignDocument } from "@/models/sign-document.entity";
import { DocumentModule } from "@/store/modules/document.store";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, PropSync } from "vue-property-decorator";

@Component({
  components: { ConfirmActionDialog, PaginatedTable }
})
export default class DocumentSelectionSimpleDialog extends mixins(PermissionMixin) {
  @PropSync("isDialogActive", { type: Boolean, default: false })
  dialogActive!: boolean;

  @Prop({ default: () => [] })
  selectedItems!: ISignDocument[];

  @Prop({ default: () => [] })
  filters!: IPageFilterElement[];

  get partnerId() {
    return PartnerModule.partner?.id || PartnerModule.partner?._id;
  }

  readonly store = DocumentModule;

  headers = [
    { text: this.$t("sign.DocumentTable.internalTitle"), align: "start", value: "title" },
    { text: this.$t("sign.DocumentTable.name"), align: "start", value: "name" },
    { text: this.$t("sign.DocumentTable.created"), align: "start", value: "timestamp.created", type: "date" }
  ];

  isLoading = false;

  get isRightDisabled() {
    return !this.selectedItems.length;
  }

  get selected() {
    return this.selectedItems;
  }

  set selected(selectedItems: ISignDocument[]) {
    this.$emit("update:selectedItems", selectedItems);
  }

  leftClick() {
    this.dialogActive = false;
    this.selected = [];
  }

  rightClick() {
    this.$emit("selected", this.selectedItems);
    this.dialogActive = false;
  }

  beforeMount() {
    const filters: IPageFilterElement[] = [...(this.filters ?? [])];
    this.store.setFilters(filters);
  }
}
</script>
